import { render } from "./Switcher.vue?vue&type=template&id=2be3a3d8"
import script from "./Switcher.vue?vue&type=script&lang=js"
export * from "./Switcher.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__